export default "__VITE_ASSET__439d19e3__"